export const TestIds = {
    timesheetsTab: "timesheets-tab",
    kbLink: "knowledge-base-link",
}
